export default __webpack_public_path__ + "ymca-logo-light.svg";